import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';

export function Descriptions({ content, contents }) {
  if (!content && !contents) return;

  const paragraphs = contents || [content];

  return (
    <Card>
      <CardHeader tag="h4" className="mt-0 tw-text-center">
        Description
      </CardHeader>
      <CardBody>
        <div className="tw-flex tw-flex-col tw-gap-2">
          {paragraphs.map((content, index) => (
            <div key={index} className="tw-italic tw-text-sm tw-text-center">
              {content}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}

export function Comments({ content, contents }) {
  if (!content && !contents) return;

  const paragraphs = contents || [content];

  return (
    <Card>
      <CardBody>
        <div className="tw-flex tw-flex-col tw-gap-2">
          {paragraphs.map((content, index) => (
            <div key={index} className="tw-italic tw-text-sm tw-text-center">
              {content}
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
}

export function Notes({ content }) {
  if (!content) return;

  return (
    <Card>
      <CardHeader tag="h4" className="mt-0 tw-text-center">
        Notes
      </CardHeader>
      <CardBody>
        <div className="tw-italic tw-text-sm tw-text-center">{content}</div>
      </CardBody>
    </Card>
  );
}
